var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.75A3.75 3.75 0 013.75 4h.887l1.025-1.611A3 3 0 018.192 1h3.615a3 3 0 012.531 1.389L15.364 4h.886A3.75 3.75 0 0120 7.75v7.5A3.75 3.75 0 0116.25 19H3.75A3.75 3.75 0 010 15.25v-7.5zM14 11a4 4 0 11-8 0 4 4 0 018 0z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCA3Ljc1QzAgNS42Nzg5MyAxLjY3ODkzIDQgMy43NSA0SDQuNjM2NTRMNS42NjIwMSAyLjM4OTAzQzYuMjEyNzIgMS41MjM4OCA3LjE2NzIyIDEgOC4xOTI3NyAxSDExLjgwNzJDMTIuODMyOCAxIDEzLjc4NzMgMS41MjM4OCAxNC4zMzggMi4zODkwM0wxNS4zNjM1IDRIMTYuMjVDMTguMzIxMSA0IDIwIDUuNjc4OTMgMjAgNy43NVYxNS4yNUMyMCAxNy4zMjExIDE4LjMyMTEgMTkgMTYuMjUgMTlIMy43NUMxLjY3ODkzIDE5IDAgMTcuMzIxMSAwIDE1LjI1VjcuNzVaTTE0IDExQzE0IDEzLjIwOTEgMTIuMjA5MSAxNSAxMCAxNUM3Ljc5MDg2IDE1IDYgMTMuMjA5MSA2IDExQzYgOC43OTA4NiA3Ljc5MDg2IDcgMTAgN0MxMi4yMDkxIDcgMTQgOC43OTA4NiAxNCAxMVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgPhoto as ReactComponent };